import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImagePopupDirective } from '@fi-shared/fi-media-bank-file-reference-preview/image-popup.directive';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, FiVimeoModule, MatIconModule],
    declarations: [ImagePopupDirective],
    exports: [ImagePopupDirective],
})
export class FiMediaBankFileReferencePreviewModule {}
